import { PlaylistRemove } from '@mui/icons-material'
import { Button, IconButton, Slider, Stack, Tooltip } from '@mui/material'
import { Document } from '@/types/documents'
import useSplitDocuments from './useSplitDocuments'

type SplitDocumentOptionsProps = {
  pages: Document['document_pages']
  splitDocumentsData: ReturnType<typeof useSplitDocuments>
}

export default function SplitDocumentOptions({
  pages,
  splitDocumentsData,
}: SplitDocumentOptionsProps) {
  const { pagesPerSplit, splitPoints, setPagesPerSplit, setSplitPoints } =
    splitDocumentsData

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Slider
          value={pagesPerSplit}
          min={1}
          max={9}
          onChange={(_, value) => setPagesPerSplit(value as number)}
          sx={{ width: 100 }}
          size="small"
        />
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            const points = []
            for (let i = pagesPerSplit; i < pages.length; i += pagesPerSplit) {
              points.push(i)
            }
            setSplitPoints(points)
          }}
          sx={{
            whiteSpace: 'nowrap',
            textTransform: 'none',
          }}
        >
          Set split every {pagesPerSplit} page{pagesPerSplit > 1 ? 's' : ''}
        </Button>
      </Stack>

      <Tooltip title="Clear all split points">
        <span>
          <IconButton
            size="small"
            disabled={!splitPoints.length}
            onClick={() => {
              setSplitPoints([])
            }}
          >
            <PlaylistRemove />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  )
}
